import { useState, useEffect } from "react";
import { Steps, Button } from "antd";
import "./ev-home-page.css";
import StepInspection from "./ev-inspections/ev-step-inspection";
import StepAppointment from "./ev-appointment/ev-step-appointment";
import StepSellerDetails from "./ev-car-details/ev-step-seller-details";
import StepPayment from "./ev-payment/ev-payment";
import Locations from "./ev-inspections/ev-location";
import _ from "lodash";
import Ripples from "react-ripples";
import { useActions } from "../../core-units/hooks/useActions";
import { useSelector } from "react-redux";

const { Step } = Steps;

const HomePageComponent = (props) => {
  const addEvField = useSelector((state) => state.booking.additionalfields);
  const evPaymentDetails = useSelector((state) => state.booking.paymentDetails);

  const [evCurrent, setEvCurrent] = useState(0);
  const [isEvAlert, setIsEvAlert] = useState(false);
  const [evCheck1, setEvCheck1] = useState(false);
  const [evCheck2, setEvCheck2] = useState(false);
  const [isEvSlotAvailable, setIsEvSlotAvailable] = useState(true);
  const [evInspectFlag, setEvInspectFlag] = useState(false);
  const [appEvFlag, setAppEvFlag] = useState(false);
  const [evTotal, setEvTotal] = useState(0);
  const [evFeildStatus, setEvFieldStatus] = useState(false);
  const [evRego, setEvRego] = useState("");
  const [askingEvPriceValidation, setAskingEvPriceValidation] = useState(true);

  const [evClientValues, setEvClientValues] = useState({
    name: "",
    email: "",
    phone: "",
  });

  /* ---------------- Handlers ---------------- */
  const validationHandler = () => setEvInspectFlag(true);
  const AppvalidationHandler = () => setAppEvFlag(true);
  const checkValidationHandler = (val) => setEvCheck2(val);
  const termsValidationHandler = (val) => setEvCheck1(val);
  const formvalidateHandler = (val) => setEvFieldStatus(val);
  const regoValidation = (val) => setEvRego(val);
  /* ---------------- Asking price validation ---------------- */
  const askingEvPriceValidations = (params) => {
    let prodId = [];

    if (localStorage.getItem("evProduct")) {
      const product = JSON.parse(params);
      if (Array.isArray(product)) {
        product.forEach((val) => prodId.push(val.id));
      }

      if (prodId.includes(4)) {
        const price = localStorage.getItem("evPrice");
        setAskingEvPriceValidation(price !== null && price !== "null");
      }
    }

    if (!prodId.includes(4)) {
      setAskingEvPriceValidation(true);
      localStorage.removeItem("evPrice");
    }
  };

  /* ---------------- Steps ---------------- */
  const steps = [
    {
      content: (
        <StepInspection
          {...props}
          validationHandler={validationHandler}
          askingPriceValidations={askingEvPriceValidations}
          setAskingPriceValidation={setAskingEvPriceValidation}
          askingPriceValidation={askingEvPriceValidation}
        />
      ),
    },
    {
      content: (
        <StepAppointment
          {...props}
          AppvalidationHandler={AppvalidationHandler}
          isSlotAvailable={isEvSlotAvailable}
          setIsSlotAvailable={setIsEvSlotAvailable}
        />
      ),
    },
    {
      content: (
        <StepSellerDetails
          {...props}
          formvalidateHandler={formvalidateHandler}
          regoValidation={regoValidation}
          checkValidationHandler={checkValidationHandler}
          termsValidationHandler={termsValidationHandler}
          isAlert={isEvAlert}
        />
      ),
    },
    {
      content: (
        <StepPayment
          setCurrent={setEvCurrent}
          setIsSlotAvailable={setIsEvSlotAvailable}
        />
      ),
    },
  ];

  /* ---------------- Routing validation ---------------- */
  const routingValidation = {
    route: evCurrent !== 0,
    edit: evCurrent,
    home: () => setEvCurrent(0),
  };

  const next = () => setEvCurrent((prev) => prev + 1);
  const prev = () => setEvCurrent((prev) => prev - 1);

  /* ---------------- Restore state ---------------- */
  useEffect(() => {
    setEvTotal(localStorage.getItem("evTotal"));

    const retrieveService = localStorage.getItem("evService");
    const retrivevalues = localStorage.getItem("allEvValues");
    const time = localStorage.getItem("evTime");

    const allEvValues = retrivevalues ? JSON.parse(retrivevalues) : {};

    setEvInspectFlag(!_.isEmpty(retrieveService));
    setAppEvFlag(!_.isEmpty(time));
    setEvFieldStatus(
      JSON.parse(localStorage.getItem("evFeildEvStatus")) === true,
    );
    setEvCheck1(JSON.parse(localStorage.getItem("evCheck1")) === true);
    setEvCheck2(JSON.parse(localStorage.getItem("evCheck2")) === true);

    setEvClientValues({
      name: allEvValues.name,
      email: allEvValues.email,
      phone: allEvValues.phone,
    });
  }, [evCurrent]);

  /* ---------------- Client creation ---------------- */
  const clientCreation = () => {
    const retrivevalues = localStorage.getItem("allEvValues");
    const allEvValues = retrivevalues ? JSON.parse(retrivevalues) : {};

    if (
      evClientValues.name !== allEvValues.name ||
      evClientValues.email !== allEvValues.email ||
      evClientValues.phone !== allEvValues.phone
    ) {
      setEvClientValues({
        name: allEvValues.name,
        email: allEvValues.email,
        phone: allEvValues.phone,
      });
    }
  };

  /* ---------------- Payment handler ---------------- */
  const onPaymentHandler = () => {
    const persistedFieldStatus = JSON.parse(
      localStorage.getItem("evFieldStatus") || "false",
    );
    const effectiveFieldValid = evFeildStatus || persistedFieldStatus;
    const regoSelected =
      !_.isEmpty(evRego) || !_.isEmpty(localStorage.getItem("evRego"));

    if (effectiveFieldValid && evCheck1 && evCheck2 && regoSelected) {
      setIsEvAlert(false);
      next();
      clientCreation();
    } else {
      setIsEvAlert(true);
      window.scrollTo({ top: 500, behavior: "smooth" });
    }
  };

  /* ---------------- Render ---------------- */
  return (
    <div className="EvHomePageContainer">
      <Locations {...props} routingValidation={routingValidation} />

      <div className="EvStepsSection">
        <div className="container">
          <div className="full-width">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-9">
                <Steps current={evCurrent} className="EvStepsItems">
                  <Step
                    title="Inspection Options"
                    icon={<i className="sb-checklist" />}
                  />
                  <Step
                    title="Appointment"
                    icon={<i className="sb-calendar1" />}
                  />
                  <Step
                    title="Seller & Car Details"
                    icon={<i className="sb-profile" />}
                  />
                  <Step
                    title="Payment"
                    icon={<i className="sb-mobile-payment" />}
                  />
                </Steps>
              </div>
            </div>
          </div>

          <div className="steps-content">{steps[evCurrent].content}</div>

          <div className="steps-action">
            {evCurrent < steps.length - 2 && (
              <Ripples className="buttonRipple">
                <Button
                  type="primary"
                  disabled={
                    (evCurrent === 0 &&
                      (!evInspectFlag ||
                        !localStorage.getItem("selectedEvValuelocation") ||
                        !askingEvPriceValidations)) ||
                    (evCurrent === 1 && !appEvFlag)
                  }
                  onClick={next}
                >
                  Next
                </Button>
              </Ripples>
            )}

            {evCurrent === steps.length - 2 && (
              <Button type="primary" onClick={onPaymentHandler}>
                Proceed to Payment
              </Button>
            )}

            {evCurrent > 0 &&
              !_.get(props, "paymentDetails.payment_received") && (
                <Button className="backbutton" onClick={prev}>
                  Back
                </Button>
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomePageComponent;
